import { getAllUserIdsFromTeams } from 'sales-content-partitioning/lib/TeamHelpers';
import { List } from 'foundations-components/transitional/components/List';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import UserCheckbox from './UserCheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UsersList = ({
  ownerId,
  teams,
  selectedTeams,
  selectedUsers,
  usersForTeams,
  userSearch,
  handleUserSearch,
  handleUserChange,
  canAssignContent
}) => {
  const userIdsFromSelectedTeams = getAllUserIdsFromTeams(teams, selectedTeams);
  const sortedUsers = Array.from(usersForTeams).sort((a, b) => a.fullName.localeCompare(b.fullName)).filter(user => user.fullName.toLowerCase().includes(userSearch));
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(SearchInput, {
      onChange: e => handleUserSearch(e.target.value)
    }), /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: sortedUsers.map(user => /*#__PURE__*/_jsx(UserCheckbox, {
        selectedUsers: selectedUsers,
        ownerId: ownerId,
        user: user,
        userPartOfSelectedTeams: userIdsFromSelectedTeams.includes(user.id),
        handleUserChange: handleUserChange,
        canAssignContent: canAssignContent
      }, user.id))
    })]
  });
};
export default UsersList;